{
  "Accessibility Menu": "Menu ng Aksesibilidad",
  "Reset settings": "I-reset ang mga setting",
  "Close": "Isara",
  "Content Adjustments": "Pag-aayos ng Nilalaman",
  "Adjust Font Size": "Ayusin ang Laki ng Font",
  "Highlight Title": "I-highlight ang Pamagat",
  "Highlight Links": "I-highlight ang Mga Link",
  "Readable Font": "Madaling Basahin na Font",
  "Color Adjustments": "Pag-aayos ng Kulay",
  "Dark Contrast": "Madilim na Kontrasto",
  "Light Contrast": "Maliwanag na Kontrasto",
  "High Contrast": "Mataas na Kontrasto",
  "High Saturation": "Mataas na Saturasyon",
  "Low Saturation": "Mababang Saturasyon",
  "Monochrome": "Monokromo",
  "Tools": "Mga Kasangkapan",
  "Reading Guide": "Gabay sa Pagbasa",
  "Stop Animations": "Itigil ang Mga Animasyon",
  "Big Cursor": "Malaking Cursor",
  "Increase Font Size": "Palakihin ang Laki ng Font",
  "Decrease Font Size": "Palitan ng Mas Maliit na Laki ng Font",
  "Letter Spacing": "Agwat ng Mga Titik",
  "Line Height": "Taas ng Linya",
  "Font Weight": "Timbang ng Font",
  "Dyslexia Font": "Font para sa Dyslexia",
  "Language": "Wika",
  "Open Accessibility Menu": "Buksan ang Menu ng Aksesibilidad",
  "Accessibility Profiles": "Mga Profile ng Aksesibilidad",
  "Seizure Safe Profile": "Profile na Ligtas sa Seizure",
  "Stops animations and reduces color saturation.": "Itinatigil ang mga animasyon at binabawasan ang saturation ng kulay.",
  "Blind Profile": "Profile para sa Bulag",
  "Activates the screen reader for auditory navigation.": "Ina-activate ang screen reader para sa pandinig na pag-navigate.",
  "Visually Impaired Profile": "Profile para sa May Kapansanan sa Paningin",
  "Enhances contrast and readability for low vision.": "Pinapalakas ang kontrasto at nababasa para sa mababang paningin.",
  "ADHD Friendly Profile": "Profile na Angkop sa ADHD",
  "Reduces distractions for better focus.": "Binabawasan ang mga distraksyon para sa mas mahusay na pokus.",
  "Cognitive & Learning Profile": "Profile ng Kognitibo at Pagkatuto",
  "Helpful tools for reading and comprehension.": "Mga kapaki-pakinabang na kasangkapan para sa pagbasa at pag-unawa.",
  "Motor Impaired Profile": "Profile para sa May Kapansanan sa Motor Skills",
  "Optimizes the site for keyboard-only navigation.": "Ina-optimize ang site para sa navigation gamit lamang ang keyboard.",
  "Headings": "Mga Pamagat",
  "Landmarks": "Mga Landmark",
  "Links": "Mga Link",
  "Focus element": "Elemento ng Pokus",
  "Visit link": "Bisitahin ang Link"
}